import React from 'react';

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

export interface FmStepItem {
  key?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
}

export interface FmStepsProps extends React.HTMLAttributes<HTMLOListElement> {
  current: number;
  items: FmStepItem[];
  /**
   * @internal DS-internal className prop; forbidden in route-owned code.
   */
  className?: string;
  'data-testid'?: string;
}

/** Workflow progress indicator — the design-system replacement for AntD `Steps`. */
export const FmSteps: React.FC<FmStepsProps> = ({
  current,
  items,
  className,
  'data-testid': dataTestId = 'fm-steps',
  ...rest
}) => (
  <ol className={cx('fm-steps', className)} data-testid={dataTestId} {...rest}>
    {items.map((item, index) => {
      const state = index < current ? 'complete' : index === current ? 'current' : 'pending';
      return (
        <li
          key={item.key ?? index}
          className={cx('fm-steps__item', `fm-steps__item--${state}`)}
          aria-current={state === 'current' ? 'step' : undefined}
          data-testid={`fm-step-${index}`}
        >
          <span className="fm-steps__marker" aria-hidden="true">
            {item.icon ?? index + 1}
          </span>
          <span className="fm-steps__content">
            <span className="fm-steps__title">{item.title}</span>
            {item.description ? (
              <span className="fm-steps__description">{item.description}</span>
            ) : null}
          </span>
        </li>
      );
    })}
  </ol>
);

export default FmSteps;
